import React, { useEffect, useState } from 'react'
import photo from "../../../Assets/Images/Vector.svg";
import remove from "../../../Assets/Images/remove.png";
import axios from "axios";
import { newBaseUrl } from "../../../Consts"
import { useNavigate, useParams } from 'react-router-dom';
import { useNews } from '../../../Context/NewsContext';
import { ToastContainer, toast } from 'react-toastify';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay';

function EditPostForm() {
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState();
    const [selectedCategory, setSelectedCategory] = useState(0);
    const { isPostById, getPostById } = useNews()
    const [inputs, setInputs] = useState([{ content: '', image: null }]); // Initialize with one empty inp ut
    const [loading, setLoading] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();

    const handleInputChange = (index, event) => {
        const { name, value, files } = event.target;
        const newInputs = [...inputs];

        if (files && files.length > 0) {
            const file = files[0]; // Only the first file

            // Validate file size
            const maxSizeInBytes = 512 * 1024; // 512KB
            if (file.size > maxSizeInBytes) {
                alert("File size exceeds 512KB. Please upload a smaller file.");
                return; // Exit without updating the state
            }

            // Validate file type (jpg, jpeg, png)
            const allowedTypes = ["image/jpeg", "image/png"];
            if (!allowedTypes.includes(file.type)) {
                alert("Only JPG, JPEG, or PNG files are allowed.");
                return; // Exit without updating the state
            }

            // Store the file and its corresponding image URL
            newInputs[index][name] = file;

            newInputs[index]['image_url'] = URL.createObjectURL(file);
        } else {
            newInputs[index][name] = value;
        }

        setInputs(newInputs);

        // Log updated inputs after the state update
    };

    const handleAddInput = () => {
        setInputs([...inputs, { content: null, image: null }]);
    };

    const handleRemoveInput = (index) => {
        const newInputs = [...inputs];
        newInputs.splice(index, 1);
        setInputs(newInputs);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const maxSizeInBytes = 512 * 1024; // 512KB

            // Validate file size
            if (file.size > maxSizeInBytes) {
                alert("File size exceeds 512KB. Please upload a smaller file.");
                event.target.value = null; // Reset input field
                return; // Exit the function
            }

            // Validate file type (jpg, jpeg, png)
            const allowedTypes = ["image/jpeg", "image/png"];
            if (!allowedTypes.includes(file.type)) {
                alert("Only JPG, JPEG, or PNG files are allowed.");
                event.target.value = null; // Reset input field
                return; // Exit the function
            }

            // If all validations pass, update state with selected file
            setSelectedFile(file);
        }
    };


    useEffect(() => {
        getPostById(id).then((data) => {

        }).catch((error) => {
            console.error('Error fetching Post by ID:', error);
        });
    }, []);

    useEffect(() => {
        if (isPostById?.data?.main_Post?.status) {
            setSelectedStatus(isPostById?.data?.main_Post?.status);
        }
        if (isPostById?.data?.main_Post?.content) {
            setInputs(isPostById.data.main_Post.content);
        }
    }, [isPostById]);

    const handleSaveClick = async () => {
        setLoading(true);
        try {
            const body = {
                'lang_id': isPostById?.data?.main_Post?.lang_id,
                'title': document.getElementById('title').value,
                'excerpt': document.getElementById('excerpt').value,
                'slug': document.getElementById('slug').value,
                'date': document.getElementById('date').value,
                'news_cat_id': "1",
                'status': selectedStatus,
                'image': selectedFile,
            };

            // Check if the contents array should be included
            if (inputs.length > 0) {
                // Ensure contents is populated even if only one field (content/image) is filled
                const contents = inputs.filter(input => input.content || input.image); // Filter out empty entries

                if (contents.length > 0) {
                    body['contents'] = contents; // Add contents to body
                }
            }


            const response = await axios.post(`${newBaseUrl}/api/update/post/${id}`, body, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "Authorization": `Bearer ${localStorage.getItem("token")}`
                },
            });
            toast.success('Post updated successfully!', {
                onClose: () => {
                    navigate(`/News/AllNews/${isPostById?.data?.main_Post?.lang_id == 1 ? "en" : "ar"}`, { replace: true });
                    setLoading(false);
                },
            });

        } catch (err) {
            // Handle error responses
            if (err.response && err.response.data && err.response.data.errors) {
                const errors = err.response.data.errors;
                for (const key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        errors[key].forEach((message) => {
                            toast.error(message); // Display each error message
                            console.error(message);
                        });
                    }
                }
            } else if (err.response && err.response.data && err.response.data.message) {
                toast.error(err.response.data.message);
            } else {
                toast.error("An unexpected error occurred.");
            }
            setLoading(false);
        }
    };

    return (
        <div>
            <ToastContainer autoClose={4000} pauseOnFocusLoss={false} pauseOnHover={false} />
            {(loading || !isPostById) ? <LoadingOverlay /> :
                <div className="flex justify-start bg-[#fff] rounded-lg py-[50px] px-[50px] h-[100%]">
                    <div className="flex flex-col gap-5 px-[50px]">
                        <div className="flex rounded-lg bg-[#F2F4F7]">
                            <label
                                htmlFor="fileInput"
                                className="flex flex-col items-center justify-center cursor-pointer w-[200px] h-[200px]">
                                <img
                                    src={isPostById?.data?.main_Post?.image_url != null && selectedFile == null ? isPostById?.data?.main_Post?.image_url :
                                        isPostById?.data?.main_Post?.image_url != null && selectedFile != null ? URL.createObjectURL(selectedFile) : photo}
                                    alt="File Upload"
                                    className={selectedFile == null && isPostById?.data?.main_Post?.image_url == null ? "w-[100px] h-[100px]" : "rounded-lg w-[200px] h-[200px]"}
                                />
                                <input
                                    type="file"
                                    id="fileInput"
                                    className="hidden"
                                    accept="image/jpeg, image/png"
                                    onChange={handleFileChange}
                                />
                            </label>
                        </div>
                        <div>
                            <button className="bg-[#0966AE] text-[#fff] rounded-lg py-2 my-3 w-[200px] text-[20px] font-[Cairo]"
                                onClick={handleSaveClick}
                                disabled={loading}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                    <div className="scrollable-content px-[50px]" style={{ width: '100%' }}>
                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Name <span className="text-red-500">*</span>
                        </label>

                        <input
                            type={'text'}
                            id={'title'}
                            name={'Title'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type title here`}
                            defaultValue={isPostById?.data?.main_Post?.title}
                            style={{
                                paddingBottom: "8px",
                            }}
                        />

                        {/* <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Category
                        </label>

                        <select
                            name="category"
                            id="category"
                            value={selectedCategory != 0 ? selectedCategory : isPostById?.data?.main_Post?.category?.id}
                            onChange={(e) => {
                                setSelectedCategory(e.target.value);
                            }}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 px-2 w-full h-[40px] border-[#DFEAF2] text-[#718EBF]"
                        >
                            {isPostById?.data?.NewsCategories.map((Post, index) => (
                                <option key={Post.id} value={Post.id}>{Post.name}</option>
                            ))}
                        </select> */}

                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Excerpt <span className="text-red-500">*</span>
                        </label>

                        <textarea
                            id={'excerpt'}
                            name={'Excerpt'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type excerpt here`}
                            defaultValue={isPostById?.data?.main_Post?.excerpt}
                            style={{
                                height: "80px",
                            }}
                        />

                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Slug <span className="text-red-500">*</span>
                        </label>

                        <input
                            type={'text'}
                            id={'slug'}
                            name={'Slug'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type title here`}
                            defaultValue={isPostById?.data?.main_Post?.slug}
                            style={{
                                paddingBottom: "8px",
                            }}
                        />

                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Date <span className="text-red-500">*</span>
                        </label>

                        <input
                            type={'date'}
                            id={'date'}
                            name={'Date'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type excerpt here`}
                            defaultValue={isPostById?.data?.main_Post?.date}
                        />

                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Status <span className="text-red-500">*</span>
                        </label>

                        <select
                            name="Status"
                            id="status"
                            value={selectedStatus != 0 ? selectedStatus : isPostById?.data?.main_Post?.status}
                            onChange={(e) => {
                                setSelectedStatus(e.target.value);
                            }}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 px-2 w-full h-[40px] border-[#DFEAF2] text-[#718EBF]"
                        >
                            <option value="1">Publish</option>
                            <option value="2">Draft</option>
                        </select>

                        <div className='flex flex-row items-center justify-start pt-2 pb-2'>
                            <label
                                className="block text-start text-[16px] font-[400] font-[Cairo] pb-1 pr-2"
                            >
                                Content
                            </label>
                            <a
                                className="rounded-lg bg-[#148342] text-[#fff] w-[30px] h-[30px] text-[25px] flex items-center justify-center cursor-pointer"
                                onClick={handleAddInput}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5 transform">
                                    <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                                </svg>
                            </a>
                        </div>

                        <div>
                            {inputs.map((input, index) => (
                                <div key={index} className="flex flex-row items-center justify-center gap-5">
                                    <textarea
                                        name="content"
                                        defaultValue={input?.content}
                                        onChange={(event) => handleInputChange(index, event)}
                                        className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                                        placeholder={`Type excerpt here`}
                                        style={{
                                            height: "150px",
                                        }}
                                    />
                                    <div className="flex items-center w-[150px] h-[150px] lg:w-[150px] lg:h-[150px] justify-center rounded-lg bg-[#F2F4F7]">
                                        <label className="flex items-center justify-center cursor-pointer w-[150px] h-[150px]">
                                            <img
                                                src={input.image == null ? photo : input?.image_url != null ? input?.image_url : input?.image_url != null && input.image != null ? URL.createObjectURL(input.image) : null}
                                                alt="File Upload"
                                                className={input.image == null ? "w-[75px] h-[75px]" : "rounded-lg w-[150px] h-[150px] lg:w-[150px] lg:h-[150px]"}
                                            />
                                            <input
                                                type="file"
                                                name="image"
                                                className="hidden"
                                                accept="image/jpeg, image/png"
                                                onChange={(event) => handleInputChange(index, event)}
                                            />
                                        </label>
                                    </div>

                                    {<button className="rounded-lg bg-[#AF1F24] text-[#fff] w-[50px] h-[50px] text-[25px] flex items-center justify-center cursor-pointer"
                                        onClick={() => handleRemoveInput(index)} >-</button>}
                                </div>

                            ))}

                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default EditPostForm